import React from 'react';
import './BlurLoader.css';

const BlurLoader = () => {
  return (
    <div className="blur-section-loader">
      {/* <div className="loader-spinner22" /> */}
    </div>
  );
};

export default BlurLoader;

